import { useRef, useCallback, useEffect } from "react";

function useStableCallback(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...args) => {
    // eslint-disable-next-line no-unused-expressions
    return callbackRef.current(...args);
  }, []);
}

export default useStableCallback;
